import React, { useRef } from 'react';
import { Star, StarHalf } from 'lucide-react';

function StarRating({ rating, size = 'md', interactive = false, onChange, allowHalf = true }) {
  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-5 h-5',
    lg: 'w-7 h-7'
  };

  const containerSizes = {
    sm: 'w-3 h-3',
    md: 'w-5 h-5',
    lg: 'w-7 h-7'
  };

  const stars = [1, 2, 3, 4, 5];

  const handleClick = (star, event) => {
    if (!interactive || !onChange) return;
    
    if (allowHalf) {
      // Get click position relative to the star
      const rect = event.currentTarget.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const halfWidth = rect.width / 2;
      
      // Left half = x.5, right half = x
      const value = clickX < halfWidth ? star - 0.5 : star;
      onChange(value);
    } else {
      onChange(star);
    }
  };

  // For touch devices
  const handleTouch = (star, event) => {
    if (!interactive || !onChange) return;
    
    const touch = event.touches[0];
    const rect = event.currentTarget.getBoundingClientRect();
    const touchX = touch.clientX - rect.left;
    const halfWidth = rect.width / 2;
    
    const value = allowHalf && touchX < halfWidth ? star - 0.5 : star;
    onChange(value);
  };

  return (
    <div className="flex gap-0.5">
      {stars.map((star) => {
        const filled = rating >= star;
        const half = rating >= star - 0.5 && rating < star;
        
        return (
          <button
            key={star}
            type="button"
            onClick={(e) => handleClick(star, e)}
            onTouchStart={(e) => handleTouch(star, e)}
            disabled={!interactive}
            className={`relative ${containerSizes[size]} ${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'}`}
          >
            {/* Background (empty) star */}
            <Star
              className={`${sizeClasses[size]} absolute inset-0 fill-transparent text-dive-gray`}
            />
            
            {/* Filled star (full) */}
            {filled && (
              <Star
                className={`${sizeClasses[size]} absolute inset-0 fill-dive-amber text-dive-amber`}
              />
            )}
            
            {/* Half-filled star */}
            {half && (
              <div className="absolute inset-0 overflow-hidden" style={{ width: '50%' }}>
                <Star
                  className={`${sizeClasses[size]} fill-dive-amber text-dive-amber`}
                />
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default StarRating;

